export async function nextRender() {
	return new Promise((res) => requestAnimationFrame(res));
}
